// ============================================
// ÉQUIPEMENT DU DOSSIER — marque, modèle, numéro de série, code erreur
// ============================================

import type { Ticket, UpdateTicketPayload } from '../../types';

/** Longueur maximale acceptée par le serveur pour chaque champ équipement. */
export const EQUIPEMENT_MAX = 200;

export type ChampEquipement = 'equipmentBrand' | 'equipmentModel' | 'serialNumber' | 'errorCode';

export const CHAMPS_EQUIPEMENT: Array<{ cle: ChampEquipement; libelle: string; chiffres?: boolean }> = [
  { cle: 'equipmentBrand', libelle: 'Marque' },
  { cle: 'equipmentModel', libelle: 'Modèle' },
  { cle: 'serialNumber', libelle: 'N° de série', chiffres: true },
  { cle: 'errorCode', libelle: 'Code erreur', chiffres: true },
];

export type SaisieEquipement = Record<ChampEquipement, string>;

export function saisieDepuisDossier(t: Partial<Ticket>): SaisieEquipement {
  return {
    equipmentBrand: t.equipmentBrand ?? '',
    equipmentModel: t.equipmentModel ?? '',
    serialNumber: t.serialNumber ?? '',
    errorCode: t.errorCode ?? '',
  };
}

/**
 * Champs réellement modifiés, prêts pour PUT /admin/tickets/:id. Les valeurs
 * sont nettoyées des espaces ; un champ vidé part à `null` (effacement).
 * Objet vide si rien n'a changé.
 */
export function changementsEquipement(avant: Partial<Ticket>, saisie: SaisieEquipement): UpdateTicketPayload {
  const payload: UpdateTicketPayload = {};
  for (const { cle } of CHAMPS_EQUIPEMENT) {
    const ancien = (avant[cle] ?? '').trim();
    const nouveau = saisie[cle].trim();
    if (ancien !== nouveau) payload[cle] = nouveau === '' ? null : nouveau;
  }
  return payload;
}
